export const Filters = {
	myopenissues: Symbol('myopenissues'),
	reportedbyme: Symbol('reportedbyme'),
	allopenissues: Symbol('allopenissues'),
	doneissues: Symbol('doneissues'),
	recentlyviewed: Symbol('recentlyviewed'),
	resolvedrecently: Symbol('resolvedrecently'),
	updatedrecently: Symbol('updatedrecently'),
	allissues: Symbol('allissues'),
} as const;

export const StatusCategoryValues = {
	TO_DO: '"To Do"',
	DONE: '"Done"',
	IN_PROGRESS: '"In Progress"',
} as const;
